import PropTypes from "prop-types";

import UploadIcon from "../../static/upload-icon.svg";
import RejectIcon from "../../static/reject-icon.svg";
import { useEffect } from "react";
import { Translate } from "react-localize-redux";

const OverlayC = ({ icon, text }) => {
  return (
    <div className="dropzone-overlay position-fixed d-flex justify-content-center align-items-center">
      <div className="dropzone-overlay__content d-flex flex-column align-items-center">
        <div className="dropzone-overlay__content__icon">{icon}</div>
        <div className="dropzone-overlay__content__text">{text}</div>
      </div>
    </div>
  );
};

const DropzoneOverlay = ({
  isDragActive,
  isDragReject,
  isMultiple = false,
}) => {
  useEffect(() => {
    if (isDragActive || isDragReject) {
      document.body.classList.add("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isDragActive, isDragReject]);

  if (isDragReject) {
    return (
      <OverlayC
        text={<Translate id="some-files-will-be-rejected" />}
        icon={<img src={RejectIcon} alt="Reject" className="w-100" />}
      />
    );
  }

  if (isDragActive) {
    return (
      <OverlayC
        text={
          <Translate id={`drop-${isMultiple ? `files` : `file`}-to-select`} />
        }
        icon={<img src={UploadIcon} alt="Upload" className="w-100" />}
      />
    );
  }
  return null;
};
DropzoneOverlay.propTypes = {
  isDragActive: PropTypes.bool.isRequired,
  isDragReject: PropTypes.bool.isRequired,
};

export default DropzoneOverlay;
